<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core';

const properties = defineProps<{ loading: boolean }>();

const searchResultIndexStore = useSearchResultIndexStore();
const loading = toRef(properties, 'loading');
const { progress } = useFakeProgress(loading);
const isMobile = useBreakpoints(breakpointsTailwind).smaller('lg');

// searching: the background call is running — found / empty: the 3 s its outcome stays — idle: nothing shown
const phase = ref<'idle' | 'searching' | 'found' | 'empty'>('idle');

const { start: scheduleHide, stop: cancelHide } = useTimeoutFn(
  () => {
    phase.value = 'idle';
  },
  3000,
  { immediate: false },
);

watch(loading, (isLoading) => {
  if (isLoading) {
    cancelHide();
    phase.value = 'searching';
    return;
  }
  // Dismissed while searching: the user closed this notification, its conclusion stays closed too.
  if (phase.value !== 'searching') {
    return;
  }
  phase.value = searchResultIndexStore.hasNewFilteredResults ? 'found' : 'empty';
  scheduleHide();
});

// Below lg the card lands right where the Beacon fab sits.
useBeaconFabHidden(() => phase.value !== 'idle' && isMobile.value);

const dismiss = () => {
  cancelHide();
  phase.value = 'idle';
};
</script>

<template>
  <!-- The live region stays mounted: a region inserted with its content already in place is not announced. -->
  <div role="status">
    <UiCustomFadeTransition>
      <div
        v-if="phase !== 'idle'"
        class="flex justify-center pt-4"
      >
        <ResultsBackgroundSearchToastCard
          :phase="phase"
          :progress="progress"
          @dismiss="dismiss"
        />
      </div>
    </UiCustomFadeTransition>
  </div>
</template>
